export const createOptionsTree = ({ students, value = false }) => {
  // react throws an error mutating props.
  // since .sort() in JS is in-place, we need to create a copy
  const studentsCopy = students.slice();

  return studentsCopy
    .sort((a, b) => {
      if (`${a.last_name} ${a.first_name}` < `${b.last_name} ${b.first_name}`) {
        return -1;
      }
      if (`${a.last_name} ${a.first_name}` > `${b.last_name} ${b.first_name}`) {
        return 1;
      }
      return 0;
    })
    .reduce(
      (studentsObj, student) => ({
        ...studentsObj,
        [`id-${student.user_id}`]: {
          label: `${student.first_name} ${student.last_name}`,
          id: student.user_id,
          value,
          sortString: `${student.last_name} ${student.first_name}`,
          apuid: student.apuid,
          email: student.email,
        },
      }),
      {},
    );
};

export const filterSelectedStudents = ({ students }) =>
  Object.values(students)
    .filter((student) => student.value)
    .map((student) => ({
      identifier: `AP Classroom ID ${student.id}`,
      id: student.id,
      name: student.label,
    }));
